module.exports = __webpack_public_path__ + "static/media/Funky_Sun.07c37910.png";